import React from "react";

export default function PlayCircuits() {
  return <div>PlayCircuits</div>;
}
